export { AutocompleteModule } from './autocomplete.module';



// WEBPACK FOOTER //
// /dist/src/app/shared/autocomplete/index.ts